import React from "react";

import { Header } from "../../../common";
import {
  CardView,
  ButtonView,
  ModalView,
  Input,
  Select,
  TagView,
} from "../../../controls";
//
import "./TestScreenStyles.scss";

const TestScreenView = ({}) => {
  return (
    <>
      <div className="test-container">
        <h1>Coming soon</h1>
      </div>
    </>
  );
};

export default TestScreenView;
